import * as React from 'react';
import { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import classNames from 'classnames';

import { useAppSelector } from 'src/stores';
import { AnyObject } from 'src/types';
import { Show } from 'src/components/conditions';

// import StarOfWeekImg from 'src/assets/img/editor/start-of-the-week.png';

import { CONTENT_ITEMS, SOCIALS, TEMPLATE_TYPES_CLASSES } from '../../constants';
import { onEditField } from '../../handlers';

import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd'

import { store } from 'src/stores';
import { editorActions } from '../../reducers';
// import { resolve } from 'path';
import { getPrimaryTextColor, getIcon } from '../../utils';

// import { isEqual } from 'lodash'

type FieldProps = {
  name: string,
  draggableId?: any,
  num?: number,
  type: string,
};

export const LetterContent = () => {
  const fields = useAppSelector(state => state.editor.fields);
  const { layout_type } = useAppSelector(state => state.editor.newsletterDefault);
  const [leftFields, setLeftFields] = useState([])
  const [rightFields, setRightFields] = useState([])

  // const temp = leftFields?.length || rightFields?.length;

  // useEffect(() => { 
  //   if(!fields?.length) {
  //     store.dispatch(editorActions.concatFields({ leftColumn: [], rightColumn: [] }));
  //   }
  // }, [temp])

  const clearedFields = fields.filter(field => field?.type !== 'empty-space')

  useEffect(() => {
    setLeftFields(fields.filter((item, index) => !(index % 2)));
    setRightFields(fields.filter((item, index) => index % 2));
  }, [fields?.length])

  useEffect(() => {
    setLeftFields(fields.filter((item, index) => !(index % 2)));
    setRightFields(fields.filter((item, index) => index % 2));
  }, [clearedFields?.length])


  // useEffect(() => {
  //   if(leftFields?.length || rightFields?.length) {
  //     store.dispatch(editorActions.concatFields({ leftColumn: leftFields, rightColumn: rightFields }));
  //   }
  // }, [fields.length])


  const handleDragEnd = (result: DropResult) => {
    const { destination, source } = result;

    if (!destination) return;
    if (destination.droppableId === source.droppableId && destination.index === source.index) return;

    store.dispatch(editorActions.swapFields({ id1: source.index, id2: destination.index }));
  }

  const handleDragEndTwoColumn = (result: DropResult) => {
    const { destination, source } = result;

    if (!destination) return;
    if (destination.droppableId === source.droppableId && destination.index === source.index) return;

    const id1 = source.index;
    const id2 = destination.index;

    // Drag to other column
    if (destination.droppableId !== source.droppableId) {
      // Drag from right column to left column
      if (destination.droppableId === 'droppable-collumn-1') {
        const temp = [...leftFields]
        const item = rightFields[id1]
        temp.splice(id2, 0, item)

        // Add item to column
        setLeftFields([...temp]);

        // Delete item from other column
        setRightFields(prevFields => {
          store.dispatch(editorActions.concatFields({ leftColumn: [...temp], 
          rightColumn: prevFields.filter((field, i) => i !== id1) }));

          return prevFields.filter((field, i) => i !== id1)
        });
      }

      // Drag from left column to right column
      if (destination.droppableId === 'droppable-collumn-2') {
        // Add item to column
        const temp = [...rightFields]
        const item = leftFields[id1]
        temp.splice(id2, 0, item)

        setRightFields([...temp]);

        // Delete item from other column
        setLeftFields(prevFields => {
          store.dispatch(editorActions.concatFields({ leftColumn: prevFields.filter((field, i) => i !== id1), rightColumn: [...temp] }));

          return prevFields.filter((field, i) => i !== id1)
        });
      }
    }

    // Drag in the same column
    if (destination.droppableId === source.droppableId) {
      if (destination.droppableId === 'droppable-collumn-1') {
        setLeftFields(prevFields => {
          const temp = [...prevFields]
          const [reordedItem] = temp.splice(id1, 1)
          temp.splice(id2, 0, reordedItem)
          store.dispatch(editorActions.concatFields({ leftColumn: [...temp], rightColumn: rightFields }));
          return [...temp]
        })
      }

      if (destination.droppableId === 'droppable-collumn-2') {
        setRightFields(prevFields => {
          const temp = [...prevFields]
          const [reordedItem] = temp.splice(id1, 1)
          temp.splice(id2, 0, reordedItem)
          store.dispatch(editorActions.concatFields({ leftColumn: leftFields, rightColumn: [...temp] }));
          return [...temp]
        })
      }
    }

    // store.dispatch(editorActions.concatFields({ leftColumn: leftFields, rightColumn: rightFields }));
  }

  const chooseItem = (field, i) => {
    switch (field?.type) {
      case CONTENT_ITEMS[0].id:
        return <Heading key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[1].id:
        return <Text key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i}
        type={field.type} />;

      case CONTENT_ITEMS[2].id:
        return <BorderedText key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[3].id:
        return <Divider key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[4].id:
        return <Image key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i}
        type={field.type} />;

      case CONTENT_ITEMS[5].id:
        return <ImageGroup key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[6].id:
        return <Socials key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[7].id:
        return <Button key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      // case CONTENT_ITEMS[8].id:
      //   return <StarOfWeek key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[8].id:
        return <Attendance key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[9].id:
        return <Video key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i}
        type={field.type} />;

      case CONTENT_ITEMS[10].id:
        return <DownloadButton key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[11].id:
        return <Events key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[12].id:
        return <Footer key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      case CONTENT_ITEMS[13].id:
        return <EmptySpace key={`head-${field.name}`} draggableId={`head-${field.name}`} name={field.name} num={i} type={field.type} />;

      default:
        return null;
    }
  }

  return (
    <LetterContentContainer
      handleDragEnd={handleDragEnd}
      handleDragEndTwoColumn={handleDragEndTwoColumn}
      layout_type={layout_type}
      leftChildren={leftFields.map((field, i) => chooseItem(field, i))}
      rightChildren={rightFields.map((field, i) => chooseItem(field, i))}
    >
      {fields.map((field, i) => chooseItem(field, i))}

    </LetterContentContainer>
  );
};

const LetterContentContainer: React.FC<AnyObject> = ({
  handleDragEnd,
  handleDragEndTwoColumn,
  layout_type,
  children,
  leftChildren,
  rightChildren
}) => {
  return layout_type === 'one_column' ? (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="droppable-grid">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={classNames('content-grid', 'droppable-grid', TEMPLATE_TYPES_CLASSES[layout_type])}
          >
            {children}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  ) : (
    <DragDropContext onDragEnd={handleDragEndTwoColumn}>
      <div className={classNames('content-grid', 'droppable-grid', TEMPLATE_TYPES_CLASSES[layout_type])}>
        <Droppable droppableId="droppable-collumn-1">
          {(provided) => (
            <div
              {...provided.droppableProps}
              className="droppable-collumn droppable-collumn-1"
              ref={provided.innerRef}
            >
              {leftChildren}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        <Droppable droppableId="droppable-collumn-2">
          {(provided) => (
            <div {...provided.droppableProps} className="droppable-collumn" ref={provided.innerRef} >
              {rightChildren}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </DragDropContext>
  )
}

const Heading: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();


  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="letter-content-heading letter-spacing" 
          onClick={onEditField(name, type)}
            >
            {values[name]}
          </div>
      )}
    </Draggable>
  );
};

const EmptySpace: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  return (
    // <Draggable draggableId={draggableId} index={num}>
    //   {(provided) => (
        <div
          // {...provided.draggableProps}
          // {...provided.dragHandleProps}
          // ref={provided.innerRef}
          style={{
            // ...provided.draggableProps.style,
            height: '50px',
            // border: "1px solid black",
            // marginBottom: '5px'
          }}
          className="editor__empty-space" >
        </div>
    //   )}
    // </Draggable>
  );
};

const Text: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="letter-content-text"
          onClick={onEditField(name, type)}
          dangerouslySetInnerHTML={{
            __html: values[name] ? values[name].toString('html') : ''
          }}
        />
      )}
    </Draggable>
  );
};

const BorderedText: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            ...provided.draggableProps.style,
            backgroundColor: values[name]?.background,
            color: values[name]?.font,
            wordBreak: values[name]?.break,
          }}
          ref={provided.innerRef}
          className="letter-content-text letter-content-bordered-text"
          onClick={onEditField(name, type)}
          dangerouslySetInnerHTML={{
            __html: values[name]?.value ? values[name].value.toString('html') : ''
          }}
        />
      )}
    </Draggable>
  );
};

const Divider: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();
  const { primary_color } = useAppSelector(state => state.auth?.school)

  const style = {
    borderStyle: values[name]?.id,
    borderColor: primary_color,
  };

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {provided => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className="letter-content-divider letter-spacing"
          style={{
            ...provided.draggableProps.style,
            ...style,
          }}
          onClick={onEditField(name, type)}
          ref={provided.innerRef}
        />
      )}
    </Draggable>
  );
};

const Image: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <img
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="letter-content-img letter-spacing"
          src={values[name]} alt="img"
          onClick={onEditField(name, type)}
        />
      )}
    </Draggable>
  );
};

const ImageGroup: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="letter-content-img-group letter-spacing"
          onClick={onEditField(name, type)}>

          {values[name].map((item: string) => (
            <div
              key={`${item}-letter-image`}
              className="item"
              style={{ backgroundImage: `url(${item})` }}
            />
          ))}
        </div>
      )}
    </Draggable>
  )
};

const Video: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num} disableInteractiveElementBlocking>
      {(provided) => (
        <video 
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="letter-content-img letter-spacing"
          src={values[name]}
          onClick={onEditField(name, type)}
          controls
        ></video>
      )}
    </Draggable>
  );
};

const Socials: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="letter-content-socials letter-spacing"
          onClick={onEditField(name, type)}>
          {SOCIALS.map(item => (
            <Show if={values[name][item.id]} key={`social-item-${item.id}`}>
              <img key={item.id} src={item.img} alt="social" style={item.styles} />
            </Show>
          ))}
        </div>
      )}
    </Draggable>
  );
};

const Button: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();
  const secondaryColor = useAppSelector(state => state.auth.school?.secondary_color);
  const primaryColor = useAppSelector(state => state.auth.school?.primary_color);

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          style={{
            ...provided.draggableProps.style,
            background: primaryColor,
            marginBottom: '8px',
            color: secondaryColor,
          }}
          className="letter-content-button app-button orange letter-spacing"
          onClick={onEditField(name, type)}
        >
          {values[name].btnText}
        </div>
      )}
    </Draggable>
  );
};

const StarOfWeek: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="letter-content-star letter-spacing"
          onClick={onEditField(name, type)}>
            <div style={{
              height: '40px',
              textAlign: 'left',
              padding: 0,
              backgroundRepeat: 'no-repeat',
              backgroundImage: "url('https://raw.githubusercontent.com/devstew/school-news-emails/main/assets/images/top.png')",
              backgroundPosition: 'bottom',
              backgroundSize: 'contain',
            }} />
          {/* <img className="frame" src={StarOfWeekImg} alt="StarOfWeekImg" /> */}
          <div className="frame-body" style={{height: 'inherit'}}>
            <p className="name" style={{marginBottom: 0}}>{values[name].student}</p>
            <p style={{marginBottom: 0}}>{values[name].className}</p>
          </div>
          <div style={{
            height: '12px',
            textAlign: 'left',
            padding: 0,
            backgroundRepeat: 'no-repeat',
            backgroundImage: "url('https://raw.githubusercontent.com/devstew/school-news-emails/main/assets/images/bottom.png')",
            backgroundPosition: 'top',
            backgroundSize: 'contain',
          }} />
        </div>
      )}
    </Draggable>
  );
};

const Attendance: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="letter-content-attendance letter-spacing"
          onClick={onEditField(name, type)}>
          <h1>Attendance</h1>
          {values[name].map((item: { id: number, percents: number, name: string, background: string }) => (
            <>
              <p>
                {item.name}
              </p>
              <div className="progress-bar-wrap">
                <div className="progress-bar" key={`progress-${item.id}`}>
                  <div className="percents-bar" style={{ width: `${item.percents}%`, backgroundColor: item.background }} />
                </div>
                <span>{item.percents}%</span>
              </div>
            </>
          ))}
        </div>
      )}
    </Draggable>
  );
};

const renderIcon = (type: string) => {
  const color = getPrimaryTextColor();

  switch(type) {
    case 'pdf':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 150" width="18" height="18" >
          <path fill={color} fill-rule="evenodd" d="M117.656 150h-96c-6.618 0-12-5.382-12-12v-5.983c0-3.313 2.687-6 6-6s6 2.687 6 6V138h96V63c0-3.314 2.687-6 6-6s6 2.686 6 6v75c0 6.618-5.382 12-12 12zm-39-30c-3.313 0-6-2.687-6-6V78c0-3.314 2.687-6 6-6h18c3.313 0 6 2.686 6 6 0 3.313-2.687 6-6 6h-12v6h6c3.313 0 6 2.686 6 6 0 3.313-2.687 6-6 6h-6v12c0 3.313-2.687 6-6 6zM50.379 72c8.976 0 16.277 7.301 16.277 16.277v15.445c0 8.977-7.301 16.278-16.277 16.278h-7.723c-3.313 0-6-2.687-6-6V78c0-3.314 2.687-6 6-6h7.723zm-1.723 36h1.723c2.358 0 4.277-1.919 4.277-4.278V88.277c0-2.358-1.919-4.277-4.277-4.277h-1.723v24zm76.42-64.973c-1.097 1.204-2.663 1.973-4.42 1.973h-24c-6.618 0-12-5.382-12-12V12h-63v45.044c0 3.313-2.687 6-6 6s-6-2.687-6-6V12c0-6.619 5.382-12 12-12h63c3.35 0 6.379 1.382 8.558 3.602.534.253 1.048.561 1.505.983l31.377 28.889c2.438 2.244 2.596 6.041.352 8.479-.408.443-.879.782-1.372 1.074zm-28.42-20.346V33h11.208L96.656 22.681zm-66 65.042v4.556c0 8.669-7.052 15.721-15.721 15.721h-2.279v6c0 3.313-2.687 6-6 6s-6-2.687-6-6V78c0-3.314 2.687-6 6-6h8.279c8.669 0 15.721 7.054 15.721 15.723zm-18 8.277h2.279c2.051 0 3.721-1.67 3.721-3.721v-4.556c0-2.053-1.67-3.723-3.721-3.723h-2.279v12z" />
        </svg>
      );
    case 'doc':
      return (
        <svg width="18px" height="18px" viewBox="0 0 134 134" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="Final" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="word">
              <rect id="Rectangle-Copy-11" stroke="#979797" fill={color} opacity="0" x="0.5" y="0.5" width="18" height="18"></rect>
              <path d="M113.50951,50.3331857 C115.58804,50.3331857 117.27302,52.0181666 117.27302,54.0966959 L117.273,54.333 L117.275,54.333 L117.276,122.09 C117.276,123.7 116.626,125.13 115.576,126.19 C114.516,127.25 113.086,127.89 111.476,127.89 L25.296,127.89 C23.686,127.89 22.256,127.25 21.196,126.19 C20.136,125.13 19.496,123.7 19.496,122.09 L19.496,108.537 L19.496,108.53752 L19.496,107.103186 C19.496,105.021072 21.1838865,103.333186 23.266,103.333186 C25.3481135,103.333186 27.036,105.021072 27.036,107.103186 L27.036,108.53752 L27.035,108.537 L27.036,119.69 C27.036,119.83 27.126,120.01 27.216,120.1 C27.306,120.24 27.496,120.28 27.626,120.28 L109.136,120.28 C109.316,120.28 109.306,120.19 109.406,120.1 C109.546,120.01 109.736,119.82 109.736,119.69 L109.736,108.53 L109.746,62 L109.745,54.333 L109.746,54.333 L109.746,54.0966959 C109.746,52.0181666 111.430981,50.3331857 113.50951,50.3331857 Z M54.001,70.096 C56.113,70.096 57.967,70.57 59.563,71.518 C61.159,72.466 62.407,73.84 63.307,75.64 C64.207,77.44 64.657,79.612 64.657,82.156 C64.657,84.7 64.207,86.89 63.307,88.726 C62.407,90.562 61.159,91.972 59.563,92.956 C57.967,93.94 56.113,94.432 54.001,94.432 C51.889,94.432 50.035,93.94 48.439,92.956 C46.843,91.972 45.595,90.562 44.695,88.726 C43.795,86.89 43.345,84.7 43.345,82.156 C43.345,79.588 43.795,77.41 44.695,75.622 C45.595,73.834 46.843,72.466 48.439,71.518 C50.035,70.57 51.889,70.096 54.001,70.096 Z M21.436,70.528 L23.056,81.508 C23.2,82.732 23.356,83.962 23.524,85.198 C23.692,86.434 23.848,87.676 23.992,88.924 L24.136,88.924 C24.376,87.676 24.61,86.434 24.838,85.198 C25.066,83.962 25.3,82.732 25.54,81.508 L28.06,70.528 L32.56,70.528 L35.08,81.508 C35.32,82.684 35.554,83.896 35.782,85.144 C36.01,86.392 36.244,87.652 36.484,88.924 L36.628,88.924 C36.796,87.652 36.958,86.398 37.114,85.162 C37.27,83.926 37.432,82.708 37.6,81.508 L39.22,70.528 L44.296,70.528 L40.12,94 L33.46,94 L31.156,83.344 C30.964,82.432 30.79,81.514 30.634,80.59 C30.478,79.666 30.34,78.772 30.22,77.908 L30.076,77.908 C29.932,78.772 29.782,79.666 29.626,80.59 C29.47,81.514 29.296,82.432 29.104,83.344 L26.908,94 L20.356,94 L16,70.528 L21.436,70.528 Z M74.47,70.528 C76.126,70.528 77.638,70.75 79.006,71.194 C80.374,71.638 81.466,72.388 82.282,73.444 C83.098,74.5 83.506,75.964 83.506,77.836 C83.506,79.564 83.128,80.986 82.372,82.102 C81.616,83.218 80.602,84.052 79.33,84.604 L84.658,94 L78.718,94 L74.218,85.54 L71.302,85.54 L71.302,94 L66.01,94 L66.01,70.528 L74.47,70.528 Z M91.627,70.528 C94.027,70.528 96.103,70.936 97.855,71.752 C99.607,72.568 100.969,73.834 101.941,75.55 C102.913,77.266 103.399,79.468 103.399,82.156 C103.399,84.844 102.919,87.064 101.959,88.816 C100.999,90.568 99.661,91.87 97.945,92.722 C96.229,93.574 94.219,94 91.915,94 L85.003,94 L85.003,70.528 L91.627,70.528 Z M54.001,74.668 C52.393,74.668 51.121,75.328 50.185,76.648 C49.249,77.968 48.781,79.804 48.781,82.156 C48.781,84.508 49.249,86.38 50.185,87.772 C51.121,89.164 52.393,89.86 54.001,89.86 C55.609,89.86 56.881,89.164 57.817,87.772 C58.753,86.38 59.221,84.508 59.221,82.156 C59.221,79.804 58.753,77.968 57.817,76.648 C56.881,75.328 55.609,74.668 54.001,74.668 Z M91.303,74.812 L90.295,74.812 L90.295,89.716 L91.303,89.716 C92.647,89.716 93.817,89.476 94.813,88.996 C95.809,88.516 96.583,87.724 97.135,86.62 C97.687,85.516 97.963,84.028 97.963,82.156 C97.963,80.284 97.687,78.814 97.135,77.746 C96.583,76.678 95.809,75.922 94.813,75.478 C93.817,75.034 92.647,74.812 91.303,74.812 Z M74.038,74.74 L71.302,74.74 L71.302,81.328 L74.038,81.328 C75.43,81.328 76.492,81.034 77.224,80.446 C77.956,79.858 78.322,78.988 78.322,77.836 C78.322,76.684 77.956,75.88 77.224,75.424 C76.492,74.968 75.43,74.74 74.038,74.74 Z M84.426,5 C85.066,5 85.716,5.28 86.176,5.69 L86.266,5.69 C86.356,5.74 86.406,5.78 86.496,5.87 L116.486,36.23 C116.996,36.74 117.366,37.43 117.366,38.21 C117.366,38.44 117.316,38.62 117.276,38.86 L117.275,42.333 L106.496,42.3331857 L106.496,42.339 L89.076,42.34 C86.906,42.34 83.886,41.17 82.456,39.74 C81.026,38.31 80.156,35.73 80.156,33.57 L80.156,12.64 L27.636,12.64 C27.456,12.64 27.316,12.73 27.226,12.82 C27.076,12.92 27.036,13.05 27.036,13.24 L27.035,58.333 L27.036,58.3331857 L27.036,59.7675202 C27.036,61.8496337 25.3481135,63.5375202 23.266,63.5375202 C21.1838865,63.5375202 19.496,61.8496337 19.496,59.7675202 L19.496,59.7675202 L19.496,58.3331857 L19.496,58.333 L19.496,10.85 C19.496,9.24 20.146,7.81 21.196,6.75 C22.256,5.69 23.726,5.05 25.296,5.05 L84.016,5.05 C84.146,5 84.286,5 84.426,5 Z M87.006,13.94 L87.006,32.97 C87.006,33.71 87.326,34.4 87.786,34.86 C88.245,35.274 88.8093,35.5746 89.45703,35.63058 L89.676,35.64 L108.436,35.64 L87.006,13.94 Z" id="Combined-Shape-Copy-3" fill={color} fill-rule="nonzero"></path>
            </g>
          </g>
        </svg>
      );
    case 'img':
      return (
        <svg width="18px" height="18px" viewBox="0 0 134 134" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="Final" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="jpg">
              <rect id="Rectangle-Copy-13" stroke="#979797" fill={color} opacity="0" x="0.5" y="0.5" width="18" height="18"></rect>
              <path d="M113.43751,50.3331857 C115.51604,50.3331857 117.20102,52.0181666 117.20102,54.0966959 L117.201,54.333 L117.203,54.333 L117.204,122.09 C117.204,123.7 116.554,125.13 115.504,126.19 C114.444,127.25 113.014,127.89 111.404,127.89 L25.224,127.89 C23.614,127.89 22.184,127.25 21.124,126.19 C20.064,125.13 19.424,123.7 19.424,122.09 L19.424,107.103186 C19.424,105.021072 21.1118865,103.333186 23.194,103.333186 C25.2761135,103.333186 26.964,105.021072 26.964,107.103186 L26.964,108.53752 L26.962,108.537 L26.964,119.69 C26.964,119.83 27.054,120.01 27.144,120.1 C27.234,120.24 27.424,120.28 27.554,120.28 L109.064,120.28 C109.244,120.28 109.234,120.19 109.334,120.1 C109.474,120.01 109.664,119.82 109.664,119.69 L109.664,108.53 L109.674,62 L109.673,54.333 L109.673,54.333 L109.674,54.0966959 C109.674,52.0181666 111.358981,50.3331857 113.43751,50.3331857 Z M31.084,70.528 L31.084,86.188 C31.084,87.7 30.82,89.08 30.292,90.328 C29.764,91.576 28.942,92.572 27.826,93.316 C26.71,94.06 25.288,94.432 23.56,94.432 C21.784,94.432 20.284,94.078 19.06,93.37 C17.836,92.662 16.816,91.6 16,90.184 L19.6,87.52 C20.032,88.312 20.536,88.9 21.112,89.284 C21.688,89.668 22.276,89.86 22.876,89.86 C23.836,89.86 24.562,89.566 25.054,88.978 C25.546,88.39 25.792,87.316 25.792,85.756 L25.792,70.528 L31.084,70.528 Z M78.811,70.096 C80.515,70.096 81.979,70.408 83.203,71.032 C84.427,71.656 85.423,72.364 86.191,73.156 L83.419,76.54 C82.819,76.012 82.183,75.568 81.511,75.208 C80.839,74.848 79.999,74.668 78.991,74.668 C77.167,74.668 75.679,75.34 74.527,76.684 C73.375,78.028 72.799,79.876 72.799,82.228 C72.799,84.628 73.351,86.5 74.455,87.844 C75.559,89.188 77.203,89.86 79.387,89.86 C79.867,89.86 80.335,89.8 80.791,89.68 C81.247,89.56 81.619,89.38 81.907,89.14 L81.907,85.108 L78.019,85.108 L78.019,80.788 L86.587,80.788 L86.587,91.588 C85.771,92.38 84.685,93.052 83.329,93.604 C81.973,94.156 80.479,94.432 78.847,94.432 C76.711,94.432 74.773,93.976 73.033,93.064 C71.293,92.152 69.913,90.802 68.893,89.014 C67.873,87.226 67.363,85.024 67.363,82.408 C67.363,79.816 67.885,77.602 68.929,75.766 C69.973,73.93 71.359,72.526 73.087,71.554 C74.815,70.582 76.723,70.096 78.811,70.096 Z M41.509,70.528 C43.237,70.528 44.803,70.762 46.207,71.23 C47.611,71.698 48.733,72.484 49.573,73.588 C50.413,74.692 50.833,76.192 50.833,78.088 C50.833,79.912 50.413,81.412 49.573,82.588 C48.733,83.764 47.617,84.634 46.225,85.198 C44.833,85.762 43.309,86.044 41.653,86.044 L38.737,86.044 L38.737,94 L33.445,94 L33.445,70.528 L41.509,70.528 Z M66.514,70.528 L66.514,74.992 L57.118,74.992 L57.118,79.708 L65.11,79.708 L65.11,84.136 L57.118,84.136 L57.118,89.536 L66.874,89.536 L66.874,94 L51.826,94 L51.826,70.528 L66.514,70.528 Z M41.185,74.74 L38.737,74.74 L38.737,81.832 L41.329,81.832 C44.209,81.832 45.649,80.584 45.649,78.088 C45.649,76.864 45.265,76 44.497,75.496 C43.729,74.992 42.625,74.74 41.185,74.74 Z M84.354,5 C84.994,5 85.644,5.28 86.104,5.69 L86.194,5.69 C86.284,5.74 86.334,5.78 86.424,5.87 L116.414,36.23 C116.924,36.74 117.294,37.43 117.294,38.21 C117.294,38.44 117.244,38.62 117.204,38.86 L117.203,42.333 L106.424,42.3331857 L106.424,42.339 L89.004,42.34 C86.834,42.34 83.814,41.17 82.384,39.74 C80.954,38.31 80.084,35.73 80.084,33.57 L80.084,12.64 L27.564,12.64 C27.384,12.64 27.244,12.73 27.154,12.82 C27.004,12.92 26.964,13.05 26.964,13.24 L26.962,58.333 L26.964,58.3331857 L26.964,59.7675202 C26.964,61.8496337 25.2761135,63.5375202 23.194,63.5375202 C21.1118865,63.5375202 19.424,61.8496337 19.424,59.7675202 L19.424,59.7675202 L19.424,10.85 C19.424,9.24 20.074,7.81 21.124,6.75 C22.184,5.69 23.654,5.05 25.224,5.05 L83.944,5.05 C84.074,5 84.214,5 84.354,5 Z M86.934,13.94 L86.934,32.97 C86.934,33.71 87.254,34.4 87.714,34.86 C88.173,35.274 88.7373,35.5746 89.38503,35.63058 L89.604,35.64 L108.364,35.64 L86.934,13.94 Z" id="Combined-Shape-Copy-3" fill={color} fill-rule="nonzero"></path>
            </g>
          </g>
        </svg>
      );
    default:
      return '';
  }
};

const DownloadButton: React.FC<FieldProps> = (props) => {

  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();
  const primary_color = useAppSelector(state => state.auth.school?.primary_color);
  const secondary_color = useAppSelector(state => state.auth.school?.secondary_color);
  const textColor = getPrimaryTextColor();
  const icon = getIcon(values[name]?.url || '');

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          style={{
            ...provided.draggableProps.style,
            background: primary_color,
            marginBottom: '8px',
            color: textColor,
          }}
          className="letter-content-button app-button orange letter-spacing"
          onClick={onEditField(name, type)}>
          {renderIcon(icon)}
          {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 150" width="18" height="18" >
            <path fill={textColor} fillRule="evenodd" d="M117.656 150h-96c-6.618 0-12-5.382-12-12v-5.983c0-3.313 2.687-6 6-6s6 2.687 6 6V138h96V63c0-3.314 2.687-6 6-6s6 2.686 6 6v75c0 6.618-5.382 12-12 12zm-39-30c-3.313 0-6-2.687-6-6V78c0-3.314 2.687-6 6-6h18c3.313 0 6 2.686 6 6 0 3.313-2.687 6-6 6h-12v6h6c3.313 0 6 2.686 6 6 0 3.313-2.687 6-6 6h-6v12c0 3.313-2.687 6-6 6zM50.379 72c8.976 0 16.277 7.301 16.277 16.277v15.445c0 8.977-7.301 16.278-16.277 16.278h-7.723c-3.313 0-6-2.687-6-6V78c0-3.314 2.687-6 6-6h7.723zm-1.723 36h1.723c2.358 0 4.277-1.919 4.277-4.278V88.277c0-2.358-1.919-4.277-4.277-4.277h-1.723v24zm76.42-64.973c-1.097 1.204-2.663 1.973-4.42 1.973h-24c-6.618 0-12-5.382-12-12V12h-63v45.044c0 3.313-2.687 6-6 6s-6-2.687-6-6V12c0-6.619 5.382-12 12-12h63c3.35 0 6.379 1.382 8.558 3.602.534.253 1.048.561 1.505.983l31.377 28.889c2.438 2.244 2.596 6.041.352 8.479-.408.443-.879.782-1.372 1.074zm-28.42-20.346V33h11.208L96.656 22.681zm-66 65.042v4.556c0 8.669-7.052 15.721-15.721 15.721h-2.279v6c0 3.313-2.687 6-6 6s-6-2.687-6-6V78c0-3.314 2.687-6 6-6h8.279c8.669 0 15.721 7.054 15.721 15.723zm-18 8.277h2.279c2.051 0 3.721-1.67 3.721-3.721v-4.556c0-2.053-1.67-3.723-3.721-3.723h-2.279v12z" />
          </svg> */}
          <span style={{marginLeft: 8}}>{values[name].name}</span>
        </div>
      )}
    </Draggable>
  );
};

const Events: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="letter-content-events letter-spacing"
          onClick={onEditField(name, type)}>
          <h1>Events</h1>
          {values[name].map((item: AnyObject) => (
            <div className="event-item" key={`event-${item.id}`}>
              <div>
                <div className="event-date">
                  <span>{item.date?.format('DD')}</span>
                  <span className="mount">{item.date?.format('MMM')}</span>
                </div>
                <div className="event-time">{item.time?.format('HH:mm')}</div>
              </div>
              <div className="event-content">
                <div className="title">{item.title}</div>
                <div className="description">{item.description}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Draggable>
  );
};



const Footer: React.FC<FieldProps> = (props) => {
  const { name, type, num, draggableId } = props;
  const { values } = useFormikContext<AnyObject>();
  const primaryColor = useAppSelector(state => state.auth.school?.primary_color);

  if (!values[name]) return null;

  return (
    <Draggable draggableId={draggableId} index={num}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          style={{
            ...provided.draggableProps.style,
            background: primaryColor
          }}
          className="letter-content-footer" onClick={onEditField(name, type)} >
          {values[name]}
        </div>
      )}
    </Draggable>
  );
};
